export const getTagColorProps = (value: string | number) => {
  let color: string | undefined;

  if (value === "Open" || value === 0) {
    color = "green";
  } else if (value === "Draft" || value === 7) {
    color = "blue";
  }

  const props: any = {};

  if (color) {
    props.color = color;
  }

  return props;
};
